export default "__VITE_ASSET__CLM$giLg__"